export const promotions = {
  // cashiers promo
  cashiersTournamentSide: "Cashier's Tournament",
  cashiersTournament: "Tournoi de caisse",
  cashiersCollectPoints: "Collectez des points au fur et à mesure que la GGR de vos joueurs grandit et participez au précieux tirage au sort!",
  cashiersMoreConditions: 'Plus de conditions ici',
  cashiersConditions: 'Conditions',
  cashiersRules: `Pour participer au tournoi, les joueurs inscrits sous la caisse doivent place de paris auprès de n'importe quel fournisseur sur le site.
\nPlus vos joueurs gagnent de GGR, plus vous obtiendrez de points.
\n1 TND en GGR (pari - gagné) = 0,01 point.
\nLa note du caissier est mise à jour tous les jours. La liste des caissiers gagnants sera établie en fonction de la GGR de leurs joueurs. Le tournoi se déroulera à partir de 10 Avril - 10 Mai.`,
  cashiersMyPoints: 'Mes points',
  cashiersUntilEnd: "Jusqu'à la fin du tournoi",
  cashiersRating: 'Cote de Caissier',
  cashiersId: "Caissier ID",
  cashiersPoints: "Points",
  cashiersTimer: {
      before:  'Temps restant avant le début du tournoi',
      after:  'Le tournoi est terminé',
      during:  "Jusqu'à la fin du tournoi"
    },
  cashiersDays: 'Jours',
  cashiersHours: 'Heures',
  cashiersMinutes: 'Minutes',
  cashiersOrdinalNumbers: ['1<b>st</b>', '2<b>nd</b>', '3<b>rd</b>', '4<b>th</b>', '5<b>th</b>', '6<b>th</b>', '7<b>th</b>', '8<b>th</b>', '9<b>th</b>', '10<b>th</b>'],
  cashiersTournamentText6: "À l'équilibre",
  cashiersTournamentText7: '4ème place',
  cashiersTournamentText8: '5ème-7ème place',
  cashiersTournamentText9: '8ème-10ème place',
}